<template>
    <div>
        <app-header title="Geld auszahlen" :back_path="'konto'" :back="'true'"></app-header>
        <div class="page">
            <table class="header">
                <tr>
                    <td>
                        <h1>Aktuelles Guthaben</h1>
                        <h2>CHF 9542.50</h2>
                        <h4>Aktualisiert am 18 Juni 2018</h4>
                    </td>
                    <td>
                        <img src="../../assets/images/mein_konto.png">
                    </td>
                </tr>
            </table>
            <div class="menu">
                <button @click="setActive('Banküberweisung')" :class="active=='Banküberweisung'?'active':''">
                    Banküberweisung
                </button>
                <button @click="setActive('PayPal')" :class="active=='PayPal'?'active':''">PayPal</button>
            </div>

            <form>
                <div class="form-group">
                    <label for="auszahlender">Auszuzahlender Betrag</label>
                    <input id="auszahlender" value="CHF 4500.00" class="form-control">
                </div>
                <div class="form-group">
                    <label for="Kontoinhaber">Kontoinhaber</label>
                    <input id="Kontoinhaber" value="Max Mustermann" class="form-control">
                </div>
                <div class="form-group">
                    <label for="iban">IBAN / Bank Number</label>
                    <input id="iban" value="CH90 6810 4036 5094 7" class="form-control">
                </div>
                <div v-if="active=='Banküberweisung'">
                    <div class="form-group">
                        <label for="clearing">BIC / Clearing-Nummer</label>
                        <input id="clearing" value="BC9435408" class="form-control">
                    </div>
                    <div class="form-group">
                        <label for="straße">Straße und Nr.</label>
                        <input id="straße" value="Musterstrasse 10" class="form-control">
                    </div>
                    <div class="form-group">
                        <label for="plz">PLZ und Ort</label>
                        <input id="plz" value="8853 Lachen" class="form-control">
                    </div>
                    <div class="form-group">
                        <label for="land">Land</label>
                        <input id="land" value="Schweiz" class="form-control">
                    </div>
                </div>
                <button type="button">Ausführen</button>
            </form>
        </div>


    </div>

</template>

<script>
    import Header from '../Header';
    import Footer from '../Footer_menu'

    export default {
        data() {
            return {
                active: 'Banküberweisung'
            }
        },
        components: {
            appHeader: Header,
            appFooter: Footer
        },
        methods: {
            setActive(name) {
                this.active = name;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/css/style';

    .page {
        padding-top: 60px;
        padding-bottom: 55px;
        color: #252226;
        overflow: hidden;

        table.header {
            width: 100%;

            td:first-of-type {
                width: 77.5%;
                padding-top: 20px;
                padding-left: 20px;

                h1 {
                    font-size: 2.0rem;
                    font-weight: 400;
                    letter-spacing: -0, 24px;
                    line-height: 28px;
                    margin-bottom: 3px;
                }

                h2 {
                    font-weight: 700;
                    font-size: 1.9rem;
                    margin-bottom: 3px;

                }

                h4 {
                    color: #838289;
                    font-size: 1.1rem;
                    letter-spacing: -0.3px;
                }
            }

            td:last-of-type {
                width: available;

                img {
                    padding-top: 10px;
                }
            }
        }

        .menu {
            width: 100%;
            text-align: center;
            margin-top: 30px;

            button {
                width: 49%;
                border: none;
                background-color: transparent;
                font-size: 1.5rem;
                font-weight: 600;
                color: #252226;
                padding-bottom: 10px;

                &.active {
                    color: $button_full_backGroundColor;
                    border-bottom: 2px $button_full_backGroundColor solid;
                }
            }
        }

        form {
            height: 52vh;
            padding: 0 20px;
            margin:20px 0;
            overflow: auto;

            div {
                margin-bottom: 20px;

                label {
                    color: $label-color;
                    font-size: 1.1rem;
                    line-height: 16px;
                }

                input {
                    border: none;
                    font-size: 1.5rem;
                    padding: 0;
                }
            }

            button {
                display: block;
                margin: auto;
                background-color: $button_full_backGroundColor;
                width: 100%;
                padding: 15px;
                font-size: 1.5rem;
                font-weight: 700;
                color: $betuszin;
                border: none;
                border-radius: 5px;

            }
        }


    }


</style>



// WEBPACK FOOTER //
// src/components/konto/Guthaben_auszahlen.vue